The hirer IDs of the hirer-filtered webhook subscriptions to retrieve.

A maximum of 100 identifiers may be provided.

If this is not provided then both hirer-filtered and unfiltered subscriptions will be returned.
